import { createTheme } from "@mui/material/styles";

const baseColors = {
  wht01: "#FFFFFF",
  wht02: "#F4F4F4",
  blk01: "#4A4A4A",
  gry04: "#8B99AF",
  amb50: "#F59E0B",
  blu50: "#3B82F6",
};

export const theme = createTheme({
  palette: {
    mode: "light",
    primary: {
      main: baseColors.blk01,
      contrastText: "#ffffff",
    },
    secondary: {
      main: baseColors.blu50,
      contrastText: "#ffffff",
    },
    background: {
      default: baseColors.wht02,
      paper: baseColors.wht01,
    },
    text: {
      primary: baseColors.blk01,
      secondary: baseColors.gry04,
    },
    success: { main: "#00e676" },
    warning: { main: baseColors.amb50 },
    error: { main: "#ff1744" },
    divider: "rgba(0, 0, 0, 0.08)",
  },
  typography: {
    fontFamily: "'Play', Helvetica, Arial, sans-serif",
    fontSize: 12,
    h1: { fontFamily: "'Audiowide', 'Play', sans-serif" },
    h2: { fontFamily: "'Audiowide', 'Play', sans-serif" },
    h3: { fontFamily: "'Audiowide', 'Play', sans-serif" },
    h4: { fontFamily: "'Audiowide', 'Play', sans-serif" },
    h5: { fontFamily: "'Audiowide', 'Play', sans-serif" },
    h6: { fontFamily: "'Audiowide', 'Play', sans-serif" },
    button: { fontFamily: "'Play', sans-serif", fontWeight: 700 },
  },
  shape: {
    borderRadius: 8,
  },
  components: {
    MuiPaper: {
      styleOverrides: {
        root: {
          backgroundImage: "none",
          borderRadius: 12,
          boxShadow: "0px 4px 20px rgba(0,0,0,0.05)",
          border: "1px solid rgba(0,0,0,0.05)",
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: "none",
          borderRadius: 8,
          fontWeight: 700,
          fontFamily: "'Play', sans-serif",
        },
        containedPrimary: {
          background: baseColors.blk01,
          "&:hover": {
            background: "#333",
          },
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          backgroundColor: baseColors.wht01,
          color: baseColors.blk01,
        },
      },
    },
    MuiTableCell: {
      styleOverrides: {
        head: {
          fontWeight: 700,
          color: baseColors.gry04,
          fontFamily: "'Play', sans-serif",
        },
      },
    },
  },
});
